import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import moment from "moment";
import { gettext } from "../../adapter";
import { currentDatePickerLocale } from "../../libraries/datepickerLocales";

// react-datepicker 2 uses date-fns v2 format tokens, which renamed moment's
// DD/YYYY/YY/D into dd/yyyy/yy/d (date-fns v2's uppercase D is day-of-year and
// throws a RangeError if used for days-of-month). Translate the locale's
// moment `L` format so the picker input matches the user's locale without
// tripping the token guard.
const momentToDateFns = (fmt) =>
  fmt.replace(/YYYY/g, "yyyy").replace(/YY/g, "yy").replace(/DD/g, "dd").replace(/\bD\b/g, "d");

const DateRangeField = ({ startDate, endDate, minDate, maxDate, onApply }) => {
  const [start, setStart] = useState(startDate ? new Date(startDate) : null);
  const [end, setEnd] = useState(endDate ? new Date(endDate) : null);

  useEffect(() => {
    setStart(startDate ? new Date(startDate) : null);
    setEnd(endDate ? new Date(endDate) : null);
  }, [startDate, endDate]);

  const applyIfComplete = (nextStart, nextEnd) => {
    if (nextStart && nextEnd && nextStart <= nextEnd) {
      onApply(nextStart, nextEnd);
    }
  };

  const dateFormat = momentToDateFns(moment.localeData().longDateFormat("L"));
  const locale = currentDatePickerLocale();

  return (
    <span className="dacom-daterange">
      <DatePicker
        selected={start}
        onChange={(date) => {
          setStart(date);
          applyIfComplete(date, end);
        }}
        selectsStart
        startDate={start}
        endDate={end}
        minDate={minDate ? new Date(minDate) : undefined}
        maxDate={maxDate ? new Date(maxDate) : undefined}
        dateFormat={dateFormat}
        locale={locale}
        placeholderText={gettext("From")}
      />
      <span className="dacom-daterange__sep"> &ndash; </span>
      <DatePicker
        selected={end}
        onChange={(date) => {
          setEnd(date);
          applyIfComplete(start, date);
        }}
        selectsEnd
        startDate={start}
        endDate={end}
        minDate={start || (minDate ? new Date(minDate) : undefined)}
        maxDate={maxDate ? new Date(maxDate) : undefined}
        dateFormat={dateFormat}
        locale={locale}
        placeholderText={gettext("To")}
      />
    </span>
  );
};

export default DateRangeField;
